import { render, staticRenderFns } from "./musicList.vue?vue&type=template&id=cf578c36&"
import script from "./musicList.vue?vue&type=script&lang=js&"
export * from "./musicList.vue?vue&type=script&lang=js&"
import style0 from "./musicList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports